<template>
  <section
    :id="sectionDomId(id)"
    class="table"
    :data-state="state && state !== 'none' ? state : undefined"
    :aria-labelledby="`${sectionDomId(id)}-title`"
  >
    <header class="head">
      <h2 :id="`${sectionDomId(id)}-title`" class="title">{{ title }}</h2>
      <div v-if="$slots.aside" class="aside"><slot name="aside" /></div>
    </header>
    <slot />
  </section>
</template>

<script setup lang="ts">
import { sectionDomId, type DotKind } from './phoneSettingsNav'

// A Phone Settings section: a titled, bordered table of SettingsRows. `state`
// tints the border gold like the tab dot (dashed while in review).
defineProps<{ id: string; title: string; state?: DotKind }>()
</script>

<style scoped>
.table {
  background: var(--color-bg-surface);
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--radius-lg);
}
.table[data-state="todo"] { border-color: var(--hue-gold); }
.table[data-state="wait"] { border-color: var(--hue-gold); border-style: dashed; }
.head {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: 14px var(--space-5);
  border-bottom: 1px solid var(--color-border-strong);
}
.title {
  margin: 0;
  font-size: var(--fs-base);
  font-weight: var(--fw-semibold);
  color: var(--color-text-primary);
}
.aside { margin-left: auto; display: inline-flex; align-items: center; }
.table > :deep(.settingsRow + .settingsRow) { border-top: 1px solid var(--color-border-subtle); }

@container (max-width: 680px) {
  .head { padding-inline: var(--space-4); }
}
</style>
